import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [pw, setPw] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        if (!token) return toast.error("Missing reset token");
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Password updated. Please sign in.");
            navigate("/login");
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid place-items-center px-6 bg-background">
            <div className="w-full max-w-md glass rounded-3xl p-8">
                <Link to="/" className="inline-flex items-center gap-2 mb-6">
                    <div className="w-9 h-9 rounded-xl bg-white grid place-items-center shadow-[0_0_20px_rgba(255,87,51,0.15)] overflow-hidden p-1">
                        <img src="/logo.png" alt="ParshHR Logo" className="w-full h-full object-contain" />
                    </div>
                    <span className="font-heading font-bold text-xl">ParshHR</span>
                </Link>
                <h1 className="font-heading text-3xl font-bold">Reset password</h1>
                <p className="text-muted-foreground text-sm mt-1">Choose a strong new password.</p>

                <form onSubmit={submit} className="mt-6 space-y-4">
                    <div>
                        <Label htmlFor="pw">New password</Label>
                        <Input id="pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" data-testid="reset-password" />
                    </div>
                    <Button type="submit" disabled={loading || !token} className="w-full rounded-full h-11" data-testid="reset-submit">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reset password"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
